/**
 * will redirect the browser to the SSO portal
 * will pass along optional redirect url and path params
 * to redirect back to on successful log in.
 * if already on the portal, don't need the redirect url
 * @param {string} url
 */
export function redirectToSSO({
  msg = "",
  warningMsg = "",
  successMsg = "",
  url = window.location
} = {}) {
  const currentUrl = new window.URL(url);
  let messageParams = "";
  if (msg) messageParams = `&msg=${encodeURIComponent(msg)}`;
  if (warningMsg)
    messageParams = `${messageParams}&warningMsg=${encodeURIComponent(
      warningMsg
    )}`;
  if (successMsg)
    messageParams = `${messageParams}&successMsg=${encodeURIComponent(
      successMsg
    )}`;
  const redirectUrl = currentlyOnSsoPortal()
    ? `${window.REACT_APP_SSO_URL}?${messageParams}`
    : `${window.REACT_APP_SSO_URL}?redirectUrl=${encodeURIComponent(
        currentUrl.href
      )}${messageParams}`;
  window.location.replace(redirectUrl);
}

/**
 * determines if the browser is on the SSO portal site
 * @returns {boolean}
 */
export function currentlyOnSsoPortal() {
  const currentUrl = new window.URL(window.location);
  return window.REACT_APP_SSO_URL === currentUrl.origin;
}

export function currentUrl() {
  const url = new window.URL(window.location);
  return url.origin;
}

export function generatePassword() {
  const length = 16;
  const charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let retVal = "";
  const n = charset.length;
  for (let i = 0; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}
